/**
 * Interface que representa os dados do payload JWT do Google
 */
export interface GoogleJwtPayload {
    iss: string;
    azp: string;
    aud: string;
    sub: string; // Google user ID
    email: string;
    email_verified: boolean;
    name: string;
    picture?: string;
    given_name?: string;
    family_name?: string;
    locale?: string;
    iat: number;
    exp: number;
}

/**
 * Dados extraidos do Google para preencher o formulario de registro
 */
export interface GoogleUserData {
    googleId: string;
    email: string;
    name: string;
    firstName: string;
    lastName: string;
    picture?: string;
}

/**
 * Decodifica um token JWT do Google para extrair os dados do utilizador
 * @param token - Token JWT retornado pelo Google OAuth
 * @returns Dados do utilizador ou null se falhar
 */
export const decodeGoogleJwt = (token: string): GoogleUserData | null => {
    try {
        // JWT tem 3 partes separadas por ponto: header.payload.signature
        const parts = token.split('.');
        if (parts.length !== 3) {
            console.error('Token JWT invalido: formato incorreto');
            return null;
        }

        // Decodifica o payload (segunda parte)
        const payload = parts[1];
        // Substitui caracteres URL-safe por base64 padrao
        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
        // Decodifica base64
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );

        const decoded: GoogleJwtPayload = JSON.parse(jsonPayload);

        return {
            googleId: decoded.sub,
            email: decoded.email,
            name: decoded.name,
            firstName: decoded.given_name || decoded.name.split(' ')[0] || '',
            lastName: decoded.family_name || decoded.name.split(' ').slice(1).join(' ') || '',
            picture: decoded.picture,
        };
    } catch (error) {
        console.error('Erro ao decodificar token JWT do Google:', error);
        return null;
    }
};
